import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { CountryPresenter } from '@/presenters/CountryPresenter';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export default class CountryAttendanceOnline extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.selectionOnlyFor([FilterKey.COUNTRY, FilterKey.DELIVERY_METHOD], filterSelectionState)) &&
			(await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState)) &&
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ===
				AttendanceFilterOptionValue.ONLINE
		);
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const demonym =
			CountryPresenter.demonymOf(this.getFilterOptionValueBy(FilterKey.COUNTRY, filterSelectionState) ?? '') ?? '';
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);

		const portalName = degree.toPortalName();

		const seoInfo: ISeoMetaDataInfo = {
			title: `Complete list of online universities in ${country} | ${portalName}`,
			description:
				`Looking to study online at a ${demonym} university? ` +
				`Browse our list of universities in ${country} offering online studies.`,
		};

		return Promise.resolve(seoInfo);
	}
}
